export default __webpack_public_path__ + "static/media/6-month-plan-illustration.3d3bfcae.svg";